// What the SOURCE bar should call an issue's 3D source.
//
// 'commit' was missing from the chain and fell through to "CURRENT
// STATE", so an issue deliberately pinned to a push - the whole point of
// which is to show the model as it stood THEN - claimed to be showing it
// as it is NOW.
//
// It lives here rather than in IssueResolutionPage because that module
// pulls in the WebGL viewer: a pure string function should be testable
// without booting a renderer.
export const modelSourceLabel = (issue) => {
  const source = (issue && issue.sourceModel) || null;
  const kind = source && source.kind;
  if (kind === "timeline") return "3D MODEL · REVISION VERSION";
  if (kind === "commit") return "3D MODEL · AT A PUSH";
  if (kind === "issue" || (source && source.fromIssueId)) return "3D MODEL · EXPORTED AGAINST ISSUE";
  return "3D MODEL · CURRENT STATE";
};

export default modelSourceLabel;
